import * as model from "./model.js";
import listView from "./views/listView.js";
import headerView from "./views/headerView.js";

import "core-js/stable";
import "regenerator-runtime/runtime";

// if (module.hot) {
//   module.hot.accept;
// }

const init = async function () {
  try {
    // Retrieve data from GitHub
    await model.loadGit();
    // console.log(model.git);

    // Load profil pic, username, description
    headerView.render(model.git.user);

    // Display in list
    listView.render(model.git.commits);
  } catch (err) {
    console.error(`${err.message}`);
  }
};

// window.addEventListener(`scroll`, function (e) {
//   const s1coords = listView._parentElement.getBoundingClientRect();
//   console.log(s1coords);
// });

init();
